// extracted by mini-css-extract-plugin
export var alignCenter = "DataForm-module--align-center--JZXlZ";
export var flex = "DataForm-module--flex--YJV2B";
export var flexCol = "DataForm-module--flex-col--PnmoM";
export var justifyCenter = "DataForm-module--justify-center--dStXP";
export var justifyEnd = "DataForm-module--justify-end--alQK4";
export var justifyStart = "DataForm-module--justify-start--6sZb1";
export var sticky = "DataForm-module--sticky--9grLD";